import { queryOptions } from '@tanstack/react-query'
import { queryKeys } from '../keys'
import { cancellationService } from '@/services/cancellation'

export const getCancellationsQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.cancellation.cancellations(),
    queryFn: ({ signal }) => cancellationService.cancellations({ signal }),
  })
